'use strict';

const braintreeLpmSDK = require('./braintreeLpmSDK');

// Global variables
let lpmInstance;
let shippingAddress;
let amount;

/**
 * Inits LPM instance for the next payment actions
 * @param {Promise} clientInstancePromise Braintree client instance promise
 * @returns {Promise} Resolved promise
 */
async function initLpm(clientInstancePromise) {
    return braintreeLpmSDK.createLpmPayment(clientInstancePromise)
        .then(function(localPaymentInstance) {
            lpmInstance = localPaymentInstance;

            return Promise.resolve({});
        });
}

/**
 * Updates order data
 * @param {Object} updatedShippingAddress Updates order shipping address from backend
 * @param {number} updatedAmount Updated order amount from backend
 */
function updateLpmOrderData(updatedShippingAddress, updatedAmount) {
    shippingAddress = updatedShippingAddress;
    amount = updatedAmount;
}

/**
 * Returns order shipping address
 * @returns {Object} Shipping address
 */
function getShippingAddress() {
    return shippingAddress;
}

/**
 * Creates and returns object with all options for initiating the lpm payment flow
 * @param {string} paymentMethodName Payment method name
 * @param {string} email Email address
 * @param {Object} configs Local payment methods configs
 * @returns {Object} {Object} Options object
 */
function createRequestData(paymentMethodName, email, configs) {
    return Object.assign(braintreeLpmSDK.createRequestData(shippingAddress,
        configs,
        paymentMethodName,
        email,
        amount),
    {
        onPaymentStart: function(_, continueCallback) {
            continueCallback();
        }
    });
}

/**
 * Launches the local payment flow and returns a nonce payload
 * @param {Object} reqData Options object
 * @returns {Promise} Promise resolved with a startPaymentPayload
 */
function startPayment(reqData) {
    return braintreeLpmSDK.startPayment(lpmInstance, reqData);
}

module.exports = {
    initLpm,
    updateLpmOrderData,
    getShippingAddress,
    createRequestData,
    startPayment
};
